/* eslint 'array-callback-return': 'off'  */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Modal } from "reactstrap";
import SubTitle from "components/FacilityRequestComponents/ResourceComponents/SubTitle";
import EstimatedCostDetailsModal from "components/FacilityRequestComponents/AH/EstimatedCostDetailsModal";
import styles from "../Maintenance/maintenance.module.css";
import AHstyles from "./Modules/AfterHours.module.css";
import CustomRadioButton from "./Modules/CustomRadioButton.module.css";
import user_svg from "Assets/icons/Icons__error.svg";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth, getDate, format } from "date-fns";
import { GetCalculateCost } from "action/tenantAction";
import { GetSelectedRequest, UpdateRequest } from "action/requestAction";
import { getPlacesList } from "action/facilitiesAction";
import { setAmplitudeEvent } from "amplitude/amplitude";
import TraneEnsembleDateTimepicker from "../TraneEnsembleDateTimepicker";
import { Grid } from "@mui/material";
import { mergeDateAndTime } from "./CreateAfterHoursRequest";

const formatedTime = "h:mm a";
let errorMessage = null;
class EditAfterHoursRequest extends Component {
  componentWillMount() {
    this.props.getPlacesList();
    let requestID = this.props.location.pathname.split("=")[1];
    requestID !== undefined
      ? this.props.GetSelectedRequest(requestID)
      : console.log("redirect back");
  }

  constructor(props) {
    super(props);
    this.state = {
      displayErrorMessages: false,
      navigateToAfterHoursList_state: false,
      modal: false,
      estimatedValue: "---",
      isSingleRequest: true,
      startDate: null,
      stopDate: null,
      startTime: null, // Set default time to 12 PM
      stopTime: null, // Set default time to 12 PM
      selectedZoneDetails: null,
      daysFallingBetweenDateRange: [],
      errorRecurringDaysNotSelected: false,
      errorDisableViewDetailsModallink: false,
      errorCurrentTimeError: false,
      errorStartTimeGreater: false,
      errorStartDateGreater: false,
      errorDateFields: false,
      errorEstimateCurrentTimeError: false,

      EditRequestId: 0,
      editzoneID: null,
      editTenantID: null,
      editTenantUserId: null,
      requestStatus: "-",
      spaceName: "-",
      zoneId: null,
      requestedBy: "-",
      comment: " ",
      hideRequestTypeorActiveRequest: false,
      disableStartDateTime: false,
      edit: true,
    };

    this.selectRequestType = this.selectRequestType.bind(this);
    this.toggle = this.toggle.bind(this);
    this.navigateToAfterHoursList = this.navigateToAfterHoursList.bind(this);
    this.getSingleRequestHTML = this.getSingleRequestHTML.bind(this);
    this.getRepeatingRequestHTML = this.getRepeatingRequestHTML.bind(this);
    //  this.getSelectedZoneDetails = this.getSelectedZoneDetails.bind(this);
    this.getZoneLocalTime = this.getZoneLocalTime.bind(this);
    this.getCalculatedRequestDetails =
      this.getCalculatedRequestDetails.bind(this);

    this.getEstimatedCost = this.getEstimatedCost.bind(this);
    this.StartDateChange = this.StartDateChange.bind(this);
    this.StopDateChange = this.StopDateChange.bind(this);
    this.startTimeChange = this.startTimeChange.bind(this);
    this.stopTimeChange = this.stopTimeChange.bind(this);
    this.getDaysNameBetween = this.getDaysNameBetween.bind(this);
    this.selectRepeatingDay = this.selectRepeatingDay.bind(this);
    this.onSaveRequest = this.onSaveRequest.bind(this);
    this.resetError = this.resetError.bind(this);
    this.validateDateBeforeSave = this.validateDateBeforeSave.bind(this);
    this.customiseData = this.customiseData.bind(this);
    this.verifyRequestStatusType = this.verifyRequestStatusType.bind(this);
    this.updateStopDate_WRT_StartDate =
      this.updateStopDate_WRT_StartDate.bind(this);
    this.updateStopTime_WRT_StartTime =
      this.updateStopTime_WRT_StartTime.bind(this);
  }

  StartDateChange(event) {
    this.resetError();
    if (event) {
      if (this.state.stopDate !== null) this.updateStopDate_WRT_StartDate(event);
      const dateObj = new Date(event + 'T00:00:00');
      this.setState(
        { startDate: dateObj },
        () => { this.getDaysNameBetween(); this.unCheckRepeatOnCheckBoxes(); }
      );
    } else {
      this.setState({ startDate: null, startTime: null });
    }
  }
  StopDateChange(event) {
    this.resetError();
    if (event) {
      const dateObj = new Date(event + 'T00:00:00');
      this.setState(
        { stopDate: dateObj },
        () => { this.getDaysNameBetween(); this.unCheckRepeatOnCheckBoxes(); }
      );
    } else {
      this.setState({ stopDate: null, stopTime: null });
    }
  }
  startTimeChange(event) {
    this.resetError();
    if (event) {
      if (this.state.stopTime !== null) this.updateStopTime_WRT_StartTime(event);
      const timeStr = typeof event === 'string' ? event : event;
      this.setState(
        { startTime: timeStr, onPageLoad: false },
        () => { this.getDaysNameBetween(); }
      );
    } else {
      this.setState({ startTime: null });
    }
  }
  stopTimeChange(event) {
    this.resetError();
    if (event) {
      const timeStr = typeof event === 'string' ? event : event;
      this.setState(
        { stopTime: timeStr, onPageLoad: false },
        () => { this.getDaysNameBetween(); }
      );
    } else {
      this.setState({ stopTime: null });
    }
  }
  selectRequestType() {
    this.resetError();
    this.setState({ isSingleRequest: !this.state.isSingleRequest }, () => {
      this.getDaysNameBetween();
    });
  } //Change Request Types
  navigateToAfterHoursList() {
    this.setState({ navigateToAfterHoursList_state: true });
  } //Updating state to redirect to list page.

  updateStopDate_WRT_StartDate(event) {
    const { stopDate } = this.state;
    if (!stopDate) return;
    const eventDate = new Date(event + 'T00:00:00');
    if (eventDate > stopDate) this.StopDateChange(event);
  }

  updateStopTime_WRT_StartTime(event) {
    const { startDate, stopDate, stopTime, minimumAfterHours } = this.state;
    if (!startDate || !stopDate || !stopTime) return;
    const sameDay = format(startDate, 'yyyy-MM-dd') === format(stopDate, 'yyyy-MM-dd');
    if (!sameDay) return;
    const [sH, sM] = event.split(':').map(Number);
    const [eH, eM] = typeof stopTime === 'string' ? stopTime.split(':').map(Number) : [null,null];
    if (eH === null) return;
    const startMinutes = sH * 60 + sM;
    const endMinutes = eH * 60 + eM;
    if (startMinutes >= endMinutes) {
      const newEndMinutes = startMinutes + (minimumAfterHours || 1) * 60;
      const newHour = Math.floor(newEndMinutes / 60) % 24;
      const newMinute = newEndMinutes % 60;
      const pad = (n)=> n<10? '0'+n: n;
      const newStop = pad(newHour)+':'+pad(newMinute);
      this.setState({ stopTime: newStop }, () => {
        if (newEndMinutes >= 24*60) {
          const next = new Date(stopDate);
          next.setDate(next.getDate()+1);
          this.setState({ stopDate: next });
        }
      });
    }
  }


  toggle(toggleType) {
    //Open View Details Pop up
    if (toggleType !== "close") {
      this.getCalculatedRequestDetails("viewCalculateCostModal");
      setAmplitudeEvent("View After-Hours estimated cost", {
        "Primary Offering": "TS",
        "Current Page": "Edit After-Hours page",
      });
    }
    if (this.state.estimatedValue !== "---") {
      this.setState({ modal: !this.state.modal });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.Tenant_Request_Cost !== nextProps.Tenant_Request_Cost) {
      let data = null;
      nextProps.Tenant_Request_Cost.hasOwnProperty("data")
        ? (data =
            nextProps.Tenant_Request_Cost.data.cost.currency +
            nextProps.Tenant_Request_Cost.data.cost.displayTotalAmount)
        : (data = "---");
      this.setState({ estimatedValue: data });
    }
    if (
      this.props.requestdetailsfromReducer !==
      nextProps.requestdetailsfromReducer
    ) {
      this.customiseData(nextProps.requestdetailsfromReducer);
      // this.getEstimatedCost(nextProps.requestdetailsfromReducer);
    }
  }

  customiseData(data) {
    if (data !== null || data !== undefined) {
      // Preserve original local date parts without timezone shifting.
      // Take only the date (YYYY-MM-DD) and create a neutral local Date at midnight.
      const startDateStr = data.startDateTime ? data.startDateTime.substring(0, 10) : null;
      const stopDateStr = data.stopDateTime ? data.stopDateTime.substring(0, 10) : null;
      const startDateObj = startDateStr ? new Date(startDateStr + 'T00:00:00') : null;
      const stopDateObj = stopDateStr ? new Date(stopDateStr + 'T00:00:00') : null;

      // Extract time (HH:mm) literally from original string to avoid implicit conversions.
      const startTimeString = data.startDateTime && data.startDateTime.length >= 16
        ? data.startDateTime.substring(11, 16)
        : null;
      const stopTimeString = data.stopDateTime && data.stopDateTime.length >= 16
        ? data.stopDateTime.substring(11, 16)
        : null;

      this.setState(
        {
          startDate: startDateObj,
          stopDate: stopDateObj,
          startTime: startTimeString,
          stopTime: stopTimeString,
          editzoneID: data.zoneId,
          editTenantID: data.tenantId,
          editTenantUserId: data.userId,
          spaceName: data.zoneName,
          zoneId: data.zoneId,
          comment: data.requestComment,
          requestedBy: data.userName,
          EditRequestId: data.changeRequestId,
          requestStatus: this.verifyRequestStatusType(data.status),
        },
        () => {
          this.getEstimatedCost("estimatedView");
        }
      );
    }
  }

  verifyRequestStatusType(statusValue) {
    if (statusValue === 0) {
      this.setState({
        hideRequestTypeorActiveRequest: false,
        disableStartDateTime: false,
      });
      return "Future Request";
    } else if (statusValue === 1) {
      this.setState({
        hideRequestTypeorActiveRequest: true,
        disableStartDateTime: true,
      });
      return "Active Request";
    } else if (statusValue === 4) {
      this.setState({
        hideRequestTypeorActiveRequest: false,
        disableStartDateTime: false,
      });
      return "Redundant Request";
    } else {
      this.setState({
        hideRequestTypeorActiveRequest: false,
        disableStartDateTime: false,
      });
      return "Verify Request";
    }
  }

  validateDateBeforeSave() {
    // check to see if date entries are valid
    let { startDate, stopDate, startTime, stopTime } = this.state;
    if (
      startDate === null &&
      stopDate === null &&
      startTime === null &&
      stopTime === null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date/Time and To Date/Time";
      return false;
    }
    // if start date is the only thing selected
    if (
      startDate !== null &&
      stopDate === null &&
      startTime === null &&
      stopTime === null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Time and To Date/Time";

      return false;
    }

    if (
      startDate === null &&
      stopDate !== null &&
      startTime === null &&
      stopTime === null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date/Time and To Time";

      return false;
    }

    // if start values arent null but everything else is
    if (
      startDate !== null &&
      stopDate === null &&
      startTime !== null &&
      stopTime === null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select To Date/Time";
      return false;
    }

    // if start values arent null but everything else is
    if (
      startDate !== null &&
      stopDate === null &&
      startTime !== null &&
      stopTime !== null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select To Date";
      return false;
    }
    // if start date is null but everything else isn't
    if (
      startDate === null &&
      stopDate !== null &&
      startTime !== null &&
      stopTime !== null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date";
      return false;
    }
    // if start date is null and start time but everything else is selected
    if (
      startDate === null &&
      stopDate !== null &&
      startTime === null &&
      stopTime !== null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date/Time";

      return false;
    }

    // if stop time is null but everything else is selected
    if (
      startDate !== null &&
      stopDate !== null &&
      startTime !== null &&
      stopTime === null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select To Time";

      return false;
    }

    // if start time is null but everything else is selected
    if (
      startDate !== null &&
      stopDate !== null &&
      startTime === null &&
      stopTime !== null
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Time";

      return false;
    }

    return true;
  }

  render() {
    let {
      displayErrorMessages,
      errorRecurringDaysNotSelected,
      errorStartTimeGreater,
      hideRequestTypeorActiveRequest,
    } = this.state;
    let dateSectionHTML = null;

    if (this.state.navigateToAfterHoursList_state) {
      return (
        <Redirect
          to={{
            pathname: "/FacilityManagement/AfterHours",
            state: { zoneSelectedfromDropdown: this.state.zoneId },
          }}
        />
      );
    }
    dateSectionHTML = this.state.isSingleRequest
      ? this.getSingleRequestHTML()
      : this.getRepeatingRequestHTML();

    if (displayErrorMessages) {
      if (errorRecurringDaysNotSelected) {
        errorMessage = " Please select days in repeat on.";
      } //recurring days error Message
      else if (errorStartTimeGreater) {
        errorMessage = " Start time cannot be greater than end time.";
      } //Current Time error Message
    }

    return (
      <div>
        <div className={styles.titleSection}>
          <SubTitle text={"After-Hours"} />
        </div>

        <div className={styles.whiteContainer}>
          {/* Form Section */}

          <div className={AHstyles.blueStatusContainer}>
            <p className={AHstyles.whiteStatusLabel}>{"Status"}</p>
            <p className={AHstyles.whiteStatusText}>
              {this.state.requestStatus}
            </p>
          </div>

          <div className={AHstyles.fieldrow}>
            <p className={AHstyles.documentformText}>{"Space"}</p>
            <p className={AHstyles.documentformLabel}>{this.state.spaceName}</p>

            {/* <div style={{display:'none'}}>      <AfterHoursSpacesDropDown onSelectedZoneDetails={this.getSelectedZoneDetails} defaultZoneSlection={this.state.editzoneID}   /> </div>  */}
          </div>

          {!hideRequestTypeorActiveRequest ? (
            <div className={AHstyles.fieldrow}>
              <p className={styles.documentsformLabel}>Request Type</p>
              <div className={AHstyles.radioButtonRow}>
                <label className={CustomRadioButton.customRadioBtn}>
                  Single{" "}
                  <input
                    id="radio_SingleRequest"
                    type="radio"
                    ref="SingleRequest"
                    name="requestType"
                    value="0"
                    defaultChecked="true"
                    onChange={this.selectRequestType}
                  />
                  <span className={CustomRadioButton.checkmark}></span>
                </label>
                <label className={CustomRadioButton.customRadioBtn}>
                  Repeating{" "}
                  <input
                    id="radio_RepeatingRequest"
                    type="radio"
                    ref="RepeatedRequest"
                    name="requestType"
                    value="1"
                    onChange={this.selectRequestType}
                  />
                  <span className={CustomRadioButton.checkmark}></span>
                </label>
              </div>
            </div>
          ) : null}

          {dateSectionHTML}

          <div className={AHstyles.fieldrow}>
            <p className={styles.formLabel}>{"Comments"}</p>
            <textarea
              className={styles.textarea}
              rows="5"
              ref="Comments"
              value={this.state.comment}
              onChange={(e) => this.setState({ comment: e.target.value })}
              maxLength="1000"
            />
          </div>

          <div className={AHstyles.fieldrow}>
            <p className={AHstyles.fieldlabelvalue}>Estimated Cost</p>{" "}
            <p className={AHstyles.viewdetailsLink} onClick={this.toggle}>
              View Details
            </p>
            <p className={AHstyles.estimatedValue}>
              {this.state.estimatedValue}
            </p>
            <p
              style={{
                display: this.state.errorEstimateCurrentTimeError
                  ? "initial"
                  : "none",
              }}
              className={AHstyles.estimatedErrorMessage}
            >
              {
                "Select starting time greater than current time for estimated Cost"
              }
            </p>
          </div>

          <div className={AHstyles.fieldrow}>
            <p className={AHstyles.documentformLabel}>{"Requested By"}</p>
            <p className={AHstyles.documentformText}>
              {this.state.requestedBy}
            </p>
          </div>

          <div className={AHstyles.requiredFieldcontainer}>
            {" "}
            <p className={styles.requiredFieldText}>* required fields.</p>{" "}
          </div>
        </div>

        {/* Submit buttons Section */}
        <div className={styles.buttonsSections}>
          <div className={styles.buttonsSectionsSubContainer}>
            <div
              className={styles.errorBoxMessage}
              style={{ display: displayErrorMessages ? "initial" : "none" }}
            >
              <img src={user_svg} alt="Trane Logo" height="25px" width="25px" />
              {errorMessage}
            </div>
            <button className={styles.saveButton} onClick={this.onSaveRequest}>
              SAVE
            </button>
            <button
              className={styles.cancelButton}
              onClick={this.navigateToAfterHoursList}
            >
              CANCEL
            </button>
          </div>
        </div>

        <Modal
          isOpen={this.state.modal}
          className={AHstyles.calculateCostModal}
          contentClassName={AHstyles.calculateModalContent}
        >
          <EstimatedCostDetailsModal
            onCloseModal={this.toggle}
            costDetails={this.props.Tenant_Request_Cost}
          />
        </Modal>
      </div>
    );
  }

  getSingleRequestHTML() {
    let singleRequesthtm = (
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <TraneEnsembleDateTimepicker
            edit={this.state.edit}
            editDate={this.state.startDate}
            editTime={this.state.startTime}
            label="From Date/Time"
            id="fromDateTimePicker"
            date={this.StartDateChange}
            time={this.startTimeChange}
            errorDateFields={this.state.errorDateFields}
            timeFormat={formatedTime}
            name="startDateTime"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TraneEnsembleDateTimepicker
            edit={this.state.edit}
            editDate={this.state.stopDate}
            editTime={this.state.stopTime}
            label="To Date/Time"
            id="toDateTimePicker"
            date={this.StopDateChange}
            time={this.stopTimeChange}
            errorDateFields={this.state.errorDateFields}
            timeFormat={formatedTime}
            name="endDateTime"
          />
        </Grid>
      </Grid>
    );

    return singleRequesthtm;
  }

  getRepeatingRequestHTML() {
    let { daysFallingBetweenDateRange } = this.state;
    let repeatingRequesthtm = (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <TraneEnsembleDateTimepicker
              edit={this.state.edit}
              editDate={this.state.startDate}
              editTime={this.state.startTime}
              label="From Date/Time"
              id="fromDateTimePicker"
              date={this.StartDateChange}
              time={this.startTimeChange}
              errorDateFields={this.state.errorDateFields}
              timeFormat={formatedTime}
              name="startDateTime"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TraneEnsembleDateTimepicker
              edit={this.state.edit}
              editDate={this.state.stopDate}
              editTime={this.state.stopTime}
              label="To Date/Time"
              id="toDateTimePicker"
              date={this.StopDateChange}
              time={this.stopTimeChange}
              errorDateFields={this.state.errorDateFields}
              timeFormat={formatedTime}
              name="endDateTime"
            />
          </Grid>
        </Grid>

        <div className={AHstyles.fieldrow}>
          <div
            className={
              this.state.errorRecurringDaysNotSelected
                ? AHstyles.repeatOnErrorContainer
                : null
            }
          >
            <p className={AHstyles.repeatOnLabel}>Repeat on</p>
            <div className={AHstyles.repeatOnContainer}>
              <label className={CustomRadioButton.checkboxContainer}>
                Sunday
                <input
                  type="checkbox"
                  ref="recur_Sunday"
                  disabled={!daysFallingBetweenDateRange.includes(0)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(0)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Monday
                <input
                  type="checkbox"
                  ref="recur_Monday"
                  disabled={!daysFallingBetweenDateRange.includes(1)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(1)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Tuesday
                <input
                  type="checkbox"
                  ref="recur_Tuesday"
                  disabled={!daysFallingBetweenDateRange.includes(2)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(2)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Wednesday
                <input
                  type="checkbox"
                  ref="recur_Wednesday"
                  disabled={!daysFallingBetweenDateRange.includes(3)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(3)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Thursday
                <input
                  type="checkbox"
                  ref="recur_Thursday"
                  disabled={!daysFallingBetweenDateRange.includes(4)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(4)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Friday
                <input
                  type="checkbox"
                  ref="recur_Friday"
                  disabled={!daysFallingBetweenDateRange.includes(5)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(5)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Saturday
                <input
                  type="checkbox"
                  ref="recur_Saturday"
                  disabled={!daysFallingBetweenDateRange.includes(6)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(6)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    );

    return repeatingRequesthtm;
  }

  onSaveRequest() {
    let requestDataToSubmit = null;
    requestDataToSubmit = this.getCalculatedRequestDetails("saveRequestForm");
      errorMessage = null;
  const checkedDate = this.validateDateBeforeSave();

    if (requestDataToSubmit !== undefined && checkedDate) {
      this.props.UpdateRequest(requestDataToSubmit);

      //After hours edit data set for amplitude
      let amplitude_Edit_AH_EventProperties = {};
      amplitude_Edit_AH_EventProperties["Primary Offering"] = "TS";
      amplitude_Edit_AH_EventProperties["Status"] = this.state.requestStatus;
      amplitude_Edit_AH_EventProperties["Edit request type"] =
        requestDataToSubmit.IsRepeat;
      amplitude_Edit_AH_EventProperties["Edit Comments"] =
        this.state.previous_comment === requestDataToSubmit.Comment
          ? false
          : true;
      setAmplitudeEvent(
        "Edit After-Hours request",
        amplitude_Edit_AH_EventProperties
      );
      //Save and redirect back to list
      this.navigateToAfterHoursList();
    }
  }

  getEstimatedCost(costDisplayType) {
    let requestDataToSubmit = null;
    requestDataToSubmit = this.getCalculatedRequestDetails("estimatedView");
    if (requestDataToSubmit !== undefined) {
      this.props.GetCalculateCost(requestDataToSubmit);
    }
  }

  getCalculatedRequestDetails(submitType) {
    //submitType, can be save(), viewCalculatedCost modal, estimated view
    let {
      startDate,
      stopDate,
      startTime,
      stopTime,
      editzoneID,
      editTenantID,
      editTenantUserId,
      EditRequestId,
      comment,
      isSingleRequest,
    } = this.state;

    let startDateTime = null;
    let endDateTime = null;
    let zoneLocalTime = null;
    let recuringDays = [];

    if (
      editzoneID !== null &&
      editTenantID !== null &&
      editTenantUserId !== null &&
      EditRequestId !== 0
    ) {
      // Use mergeDateAndTime to combine date and time as local time
      const startDateObj = mergeDateAndTime(startDate, startTime);
      const stopDateObj = mergeDateAndTime(stopDate, stopTime);
      startDateTime = startDateObj ? format(startDateObj, 'yyyy/MM/dd HH:mm:00') : null;
      let RecurEndTime = stopDateObj ? format(stopDateObj, 'yyyy/MM/dd HH:mm:00') : null;

      // Early validation: require start < end (strict). If invalid, set granular error.
      if (startDateObj && stopDateObj && startDateObj >= stopDateObj) {
        const sameDay = format(startDateObj, 'yyyy-MM-dd') === format(stopDateObj, 'yyyy-MM-dd');
        this.setState({
          displayErrorMessages: true,
          errorDateFields: true,
          errorStartTimeGreater: sameDay,
          errorStartDateGreater: !sameDay,
          estimatedValue: '---'
        });
        return;
      }

      if (startDateObj && stopDateObj) {
        if (isSingleRequest) {
          // Use stopDateObj to ensure local time is preserved
          endDateTime = stopDateObj ? format(stopDateObj, 'yyyy/MM/dd HH:mm:00') : null;
        } else {
          //False is Repeating request
          // get recuring days
          let twoDigitMonth =
            (getMonth(stopDate) + 1).toString().length > 1
              ? getMonth(stopDate) + 1
              : "0" + (getMonth(stopDate) + 1).toString();
          let twoDigitDay =
            getDate(stopDate).toString().length > 1
              ? getDate(stopDate)
              : "0" + getDate(stopDate).toString();
          endDateTime = `${twoDigitDay}/${twoDigitMonth}/${getYear(stopDate)}`;

          if (this.refs.recur_Sunday && this.refs.recur_Sunday.checked) {
            recuringDays.push("0");
          }
          if (this.refs.recur_Monday && this.refs.recur_Monday.checked) {
            recuringDays.push("1");
          }
          if (this.refs.recur_Tuesday && this.refs.recur_Tuesday.checked) {
            recuringDays.push("2");
          }
          if (this.refs.recur_Wednesday && this.refs.recur_Wednesday.checked) {
            recuringDays.push("3");
          }
          if (this.refs.recur_Thursday && this.refs.recur_Thursday.checked) {
            recuringDays.push("4");
          }
          if (this.refs.recur_Friday && this.refs.recur_Friday.checked) {
            recuringDays.push("5");
          }
          if (this.refs.recur_Saturday && this.refs.recur_Saturday.checked) {
            recuringDays.push("6");
          }
          // fetch recurring days
        }
        

        zoneLocalTime = this.getZoneLocalTime();
        let CurrentDateTimeOfZone =
          zoneLocalTime.getFullYear() +
          "/" +
          (zoneLocalTime.getMonth() + 1) +
          "/" +
          zoneLocalTime.getDate() +
          " " +
          zoneLocalTime.getHours() +
          ":" +
          zoneLocalTime.getMinutes() +
          ":00";

        // if (this.ValidateDate(new Date(startDateTime), new Date(CurrentDateTimeOfZone), new Date(RecurEndTime))) {
  if (this.ValidateDate(new Date(startDateTime), new Date(CurrentDateTimeOfZone), new Date(RecurEndTime))) {
          let Request = null;
          if (this.state.isSingleRequest) {
            Request = {
              StartDateTime: startDateTime,
              EndDateTime: endDateTime,
              IsRepeat: !this.state.isSingleRequest,
              TenantId: editTenantID,
              ZoneId: editzoneID,
              RequestId: EditRequestId,
              Comment: comment,
              TenantUserId: editTenantUserId,
            };
            return Request;
          } else {
            if (recuringDays.length <= 0) {
              if (submitType === "estimatedView") {
                this.setState({ estimatedValue: "---" });
              } else if (submitType === "saveRequestForm") {
                this.setState({
                  displayErrorMessages: true,
                  errorDateFields: true,
                  errorRecurringDaysNotSelected: true,
                });
                //Error recurring days not Selected
              } else if (submitType === "viewCalculateCostModal") {
                this.setState({ errorDisableViewDetailsModallink: true });
                //Do Not open Modal
              }
            } else {
              Request = {
                StartDateTime: startDateTime,
                IsRepeat: !this.state.isSingleRequest,
                TenantId: editTenantID,
                ZoneId: editzoneID,
                RequestId: EditRequestId,
                Comment: comment,
                TenantUserId: editTenantUserId,
                EndDateTime: RecurEndTime,
                RecurDays: recuringDays,
                RecurTime: endDateTime,
              };
              return Request;
            }
          }
        } else { // start before stop but start before current zone time
          if (submitType === 'saveRequestForm') {
            this.setState({
              displayErrorMessages: true,
              errorDateFields: true,
              errorCurrentTimeError: true,
              estimatedValue: '---'
            });
          } else if (submitType === 'estimatedView') {
            this.setState({
              errorEstimateCurrentTimeError: true,
              estimatedValue: '---'
            });
          }
        }
      }
    } else {
      this.setState({ estimatedValue: "---" });
    }
  }

  getZoneLocalTime() {
    let { editzoneID } = this.state;
    let zoneRecord = null;
    if (
      this.props.zonesListFromStore !== undefined ||
      this.props.zonesListFromStore !== null ||
      editzoneID !== null
    ) {
      zoneRecord = this.props.zonesListFromStore.zones.find((elememt) => {
        if (elememt.zoneId === editzoneID) {
          return elememt;
        }
      });
    }

    var localTime = new Date();
    var utc = localTime.getTime() + localTime.getTimezoneOffset() * 60000;
    let zoneOffset = null;
    zoneOffset =
      zoneRecord !== undefined || zoneRecord !== null
        ? zoneRecord.timeZoneOffset
        : 0;
    //  zoneOffset =  0;
    let localZoneTime = new Date(utc + 3600000 * zoneOffset);
    return localZoneTime;
  }

  //Repeating Request functions
  getDaysNameBetween() {
    let { isSingleRequest, startDate, stopDate } = this.state;
    //Following Function shall check the days falling between selected from and To date
    if (!isSingleRequest) {
      //Checking only for repeating request
      var from = new Date(startDate);
      var to = new Date(stopDate);
      let allDaysFallingBetweenDateRange = [];
      let daysFallingBetweenDateRange = null;

      var d = from;
      while (d <= to) {
        allDaysFallingBetweenDateRange.push(d.getDay());
        d = new Date(d.getTime() + 24 * 60 * 60 * 1000);
      }
      daysFallingBetweenDateRange = allDaysFallingBetweenDateRange.filter(
        function (elem, index, self) {
          return index === self.indexOf(elem);
        }
      );
      this.setState({
        daysFallingBetweenDateRange: daysFallingBetweenDateRange,
      });
      this.getEstimatedCost("estimatedView");
    } else {
      this.getEstimatedCost("estimatedView"); //To Do
    }
  }

  selectRepeatingDay() {
    //Check Box checking calculate estimate
    //   if(this.state.errorRecurringDaysNotSelected){this.resetError(); }   To Do: make time picker dynamic
    this.resetError();
    this.getEstimatedCost("estimatedView");
  }

  unCheckRepeatOnCheckBoxes() {
    //Uncheck Check Boxes on date changes
    if (!this.state.isSingleRequest) {
      this.refs["recur_Sunday"].checked = false;
      this.refs["recur_Monday"].checked = false;
      this.refs["recur_Tuesday"].checked = false;
      this.refs["recur_Wednesday"].checked = false;
      this.refs["recur_Thursday"].checked = false;
      this.refs["recur_Friday"].checked = false;
      this.refs["recur_Saturday"].checked = false;
    }
  }

  //Resetting Validations to False
  resetError() {
    this.setState({
      displayErrorMessages: false,
      errorRecurringDaysNotSelected: false,
      errorDisableViewDetailsModallink: false,
      errorCurrentTimeError: false,
      errorStartTimeGreater: false,
  errorStartDateGreater: false,
      errorDateFields: false,
      errorEstimateCurrentTimeError: false,
    });
  }

  ValidateDate = (fromDate, currentZoneLocalTime, endate) => {
    if (this.state.requestStatus === "Active Request") {
      return endate >= currentZoneLocalTime ? true : false;
    } else {
      // FromDate should be greater or equal to currentZoneLocalTime
      return fromDate >= currentZoneLocalTime ? true : false;
    }
  };
}

const mapStateToProps = (state) => {
  return {
    getLabels:
      state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
    getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields,
    Tenant_Request_Cost: state.tenantsRootReducer.Cost,
    requestdetailsfromReducer: state.RequestRootReducer.SelectedRequest, //  fetched details based on request ID
    zonesListFromStore: state.facilityRootReducer.places,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetCalculateCost: (data) => dispatch(GetCalculateCost(data)),
    GetSelectedRequest: (RequestId) => dispatch(GetSelectedRequest(RequestId)),
    UpdateRequest: (data) => dispatch(UpdateRequest(data)),
    getPlacesList: () => dispatch(getPlacesList()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAfterHoursRequest);
